import React, {Component} from 'react';
import memory from '../../utils/memory';
import storage from '../../utils/storage';
import { Redirect, Route, Switch } from 'react-router-dom';
import {AppProvider, Frame, Navigation, TopBar, Loading} from '@shopify/polaris';
import '@shopify/polaris/styles.css';
import {HomeMajorMonotone, CustomersMajorMonotone, CashDollarMajorMonotone, LogOutMinor} from '@shopify/polaris-icons';
import Home from "../home/home";
import Account from "../account/account";
import Payouts from "../payouts/payouts";
import logo from './shopify-bag.png'

export default class Login extends Component{
    constructor(props) {
      super(props);
      this.state = {
        user_info:{},
        isLoading:false,
        name:'affiliate',
        userMenuActive:false,
        toggleUserMenuActive:false,
        location:'/home'
      }

    }

    componentDidMount()
    {
      if (this.props.location.pathname === '/') {
        this.setState({location:'/home'})
      }else{
        this.setState({location:this.props.location.pathname})
      }


     
    }

  
    toggleIsLoading = () =>{
      this.setState({isLoading:!this.state.isLoading})
    }

    toggleUserMenuActive = () =>{
      this.setState({userMenuActive:!this.state.userMenuActive})
    }

    logout = () => {
      storage.removeInfo('user_info')
      window.location.reload()
    }
    
    render () {
        const loadingMarkup = this.state.isLoading ? <Loading /> : null;

        const theme = {
            colors: {
              topBar: {
                background: '#1C2260',
              },
            },
            //TDDO:这里需要产品提供一张图片
            logo: {
              width: 40,
              topBarSource:logo,
              url: 'https://affiliate.giraffly.com',
              accessibilityLabel: 'Giraffly Affiliate',
            },
          };

          
        const userMenuActions = [
          {
            items: [{content: 'Log out', icon: LogOutMinor, onAction: this.logout}],
          },
        ];

        const userMenuMarkup = (
          <TopBar.UserMenu
            actions={userMenuActions}
            name={memory.user_info.name}
            initials={memory.user_info.name ? memory.user_info.name.substring(0,1) : ''}
            open={this.state.userMenuActive}
            onToggle={this.toggleUserMenuActive}
          />
        );

        const topBarMarkup = (
        <TopBar
          userMenu={userMenuMarkup} 
        />
        );


        const navigationMarkup = (
            <Navigation location={this.state.location}>
              <Navigation.Section
                separator
                items={[
                  {
                    url: '/home',
                    label: 'Dashboard',
                    icon: HomeMajorMonotone,
                    onClick: this.toggleIsLoading,
                  },
                  {
                    url: '/payouts',
                    label: 'Payouts',
                    icon: CashDollarMajorMonotone,
                    onClick: this.toggleIsLoading,
                  },
                  {
                    url: '/accounts',
                    label: 'Account',
                    icon: CustomersMajorMonotone,
                    onClick: this.toggleIsLoading,
                  },
                ]}
              />
            </Navigation>
          );

        if(!memory.user_info)
        {
            return <Redirect to="/login" />
        }

        return (
            <div style={{height: '500px'}}>
              <AppProvider
                theme={theme}
                i18n={{
                  Polaris: {
                    Avatar: {
                      label: 'Avatar',
                      labelWithInitials: 'Avatar with initials {initials}',
                    },
                    ContextualSaveBar: {
                      save: 'Save',
                      discard: 'Discard',
                    },
                    TextField: {
                      characterCount: '{count} characters',
                    },
                    TopBar: {
                      toggleMenuLabel: 'Toggle menu',
        
                      SearchField: {
                        clearButtonLabel: 'Clear',
                        search: 'Search',
                      },
                    },
                    Modal: {
                      iFrameTitle: 'body markup',
                    },
                    Frame: {
                      skipToContent: 'Skip to content',
                      Navigation: {
                        closeMobileNavigationLabel: 'Close navigation',
                      },
                    },
                  },
                }}
              >
                <Frame
                  topBar={topBarMarkup}
                  navigation={navigationMarkup}
                >
                  {loadingMarkup}
                  <Switch>
                    <Route path='/home' component={Home}></Route>
                    <Route path='/accounts' component={Account}></Route>
                    <Route path='/payouts' component={Payouts}></Route>
                    <Redirect to='/home' />
                  </Switch>
                </Frame>
              </AppProvider>
            </div>
          )
    }
}